import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { DateField, NumberField, Show } from "@refinedev/mui";

export const ReceiptShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  console.log({ record });

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          Id
        </Typography>
        <NumberField value={record?.id ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Created At
        </Typography>
        <DateField value={record?.createdAt} />
        <TableContainer component={Paper} sx={{mt: 5, border: 2}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: 20, fontWeight: "bold" }}>
                  RECEIPT NUMBER
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#ef5858",
                    color: "white",
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                >
                  AMOUNT RECEIVED
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#58ef5c",
                    color: "white",
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                >
                  AMOUNT GIVEN
                </TableCell>
                <TableCell sx={{ fontSize: 20, fontWeight: "bold" }}>
                  RECEIPT CONTAINERS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(record?.receipts || [])?.map((item: any, index: number) => (
                <TableRow key={index}>
                  <TableCell sx={{
                    fontWeight: "bold"
                  }}>{item.receipt_number}</TableCell>
                  <TableCell
                    sx={{ backgroundColor: "#ef5858", color: "white", fontWeight: "bold" }}
                  >
                    {item.amount_given}
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: "#58ef5c", color: "white", fontWeight: "bold" }}
                  >
                    {item.amount_received}
                  </TableCell>
                  <TableCell align="left" sx={{
                    fontWeight: "bold"
                  }}>-</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Show>
  );
};
